module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesNatural.02c5963.webp";